import { makeAutoObservable } from 'mobx';

class popupMessageStore {
    constructor() {
        makeAutoObservable(this);
    }

    private timer: any;
    textMessage: string = '';
    statusMessage: boolean = false;

    setMessage = (inpText: string) => {
        this.textMessage = inpText;
        this.statusMessage = true;
        if (this.timer !== undefined) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => this.clearMessage(), 5000);
    };

    clearMessage = () => {
        this.statusMessage = false;
        this.textMessage = '';
    };
}

export default new popupMessageStore();
